export class WbVirtualDecorator {
  constructor() {
    this.init();
  }

  init() {
    return new Promise((resolve, reject) => {
      this.bindListeners();
      resolve();
    });
  }

  bindListeners() {
    const _this = this;

    document
      .querySelector('body')
      ._addCustomEventListener(
        'click',
        '.virtual-decorator',
        _this.openCart.bind(_this),
      );
  }

  openCart(e) {
    const language = document.getElementsByTagName('html')[0].getAttribute('lang').slice(0, 2);

    const event = new CustomEvent('__lb_show_open_cart_', {
      detail: {
        organization: e.target.dataset.organization ?? 'rinox',
        locale: language,
      },
    });
    document.body.dispatchEvent(event);
  }

}